<div class="col-md-8">
    <div class="row">
        <div class="col-md-12">
            <div class="event-container clearfix">
                <div *ngIf="bestaetigungVisible" class="alert alert-success" role="alert">Vielen Dank für Ihre Anmeldung. Weitere Informationen erhalten Sie zwei Wochen vor Veranstaltung per Email.</div>
                <div class="left-event-content">
                    <div class="event-contact">
                        <h4>Veranstaltungstermin</h4>
                        <ul>
                            <li>{{ kursDatum }}</li>
                            <li *ngIf="kurs.von && kurs.bis"> {{ kurs.von }} - {{ kurs.bis }} Uhr</li>
                        </ul>
                        <br>
                        <h4>Veranstaltungsort</h4>
                        <ul>
                            <li *ngIf="kurs.online;else veranstaltungsort">Online <p>per Videokonferenz</p></li>
                            <ng-template #veranstaltungsort>
                                <li>{{ [kurs.ort, kurs.veranstaltungsort].filter(Boolean).join(', ') }}</li>
                            </ng-template>
                        </ul>
                        <br>
                        <h4>Verfügbare Plätze</h4>
                        <ul>
                            <li>{{ verfuebarePlaetze }}</li>
                        </ul>
                        <br>
                        <div class="anmeldung">
                            <a routerLink="/meinedaten" routerLinkActive="active"
                               *ngIf="!isLoggedIn;else anmeldung">
                                <i class="pi pi-angle-double-right"></i>
                                Registrierung / Login
                            </a>
                            <ng-template #anmeldung>
                                <p-button styleClass="btn-success btn anmelden-btn" class="anmeldungs-button"
                                          (click)="zeigeOverlay()"
                                          *ngIf="istAnmeldefristEingehalten && !isAngemeldet && !anmeldungText && verfuebarePlaetze" label="Anmelden"/>

                                <p-button styleClass="btn-success btn anmelden-btn" class="anmeldungs-button"
                                          routerLink="/zertifizierungsverlauf" *ngIf="isAngemeldet" label="Anmeldung ansehen"/>

                                <p-button styleClass="btn btn-danger btn-block" class="anmeldungs-button"
                                          routerLink="/events" *ngIf="!verfuebarePlaetze && !isAngemeldet && istAnmeldefristEingehalten" label="ausgebucht"/>

                                <p-button styleClass="btn btn-danger btn-block pl-3 pr-3" class="anmeldungs-button"
                                          routerLink="/events" *ngIf="!istAnmeldefristEingehalten && !isAngemeldet" label="Anmeldefrist abgelaufen"/>

                                <button class="btn btn-success btn-block pl-3 pr-3 anmeldungs-button" disabled *ngIf="anmeldungText && istAnmeldefristEingehalten && verfuebarePlaetze && !isAngemeldet">
                                    {{ anmeldungText }}</button>
                            </ng-template>
                            <app-kurs-anmeldung (hideAnmeldenBtn)="hideAnmeldenBtn($event)"></app-kurs-anmeldung>
                        </div>
                    </div>

                </div> <!-- /.left-event-content -->
                <div class="right-event-content">
                    <h2 class="event-title">{{ titel(kurs.typ!) }}</h2>
                    <div [innerHTML]="kurs.beschreibung"></div>
                    <p>siehe <a routerLink="/kosten-storno" routerLinkActive="active">Zahlungsbedingungen</a></p>

                    <div class="google-map-canvas" id="map-canvas"></div>

                </div> <!-- /.right-event-content -->
            </div> <!-- /.event-container -->
        </div> <!-- /.col-md-12 -->
    </div> <!-- /.row -->
</div> <!-- /.col-md-8 -->
<app-keine-anmeldung></app-keine-anmeldung>

